export const defaultProps = {
  arrow: true,
  enterDelay: 300,
};
export const styleOverrides = {
  tooltip: ({ theme }) => ({
    backgroundColor: theme.palette.background.navigation,
    color: theme.palette.text.main,
    fontSize: 14,
    borderRadius: 6,
    padding: "6px 12px",
  }),
  arrow: ({ theme }) => ({
    color: theme.palette.background.navigation,
  }),
};
